<template>
    <div class="eesa-error-main">
        <div class="eesa-error-inner">
            <div class="eesa-error-img">
                <img :src="errorImg" alt="401" />
            </div>
            <div class="eesa-error-content">
                <h1>401</h1>
                <b>Unauthorized</b>
                <p>You do not have access to this resource.</p>
                <RouterLink to="/">
                    <button>Go to Home</button>
                </RouterLink>
            </div>
        </div>
    </div>
</template>

<script setup>
import errorImg from '@/assets/images/401.png'
import { RouterLink } from 'vue-router'
</script>